

import React, { memo } from 'react';
import _get from 'lodash.get';
import _isEmpty from 'lodash.isempty';
import { Image } from '../../../../../ui-kit';
import fileTypeIconMap from '../../../../../common/constants/fileTypeIconMap';
import { VIDEO, HEIC } from '../../../../../common/constants/fileTypes';
import Upload from '../../Upload';
import FileTypeIcon from '../../FileTypeIcon';
import '../styles/_image-preview.scss';










function getImageUrl(isHeicAsset, sourceUrl) {
  if (isHeicAsset) {
    return null;
  }

  return sourceUrl ? `${sourceUrl}#${Date.now()}` : sourceUrl;
}

function getOriginalThumbnail(assetFiles, showOriginalAsThumbnail) {
  if (_isEmpty(assetFiles)) {
    return {};
  }

  const { THUMBNAIL, ORIGINAL } = assetFiles;
  if (showOriginalAsThumbnail) {
    return ORIGINAL;
  }

  return !_isEmpty(THUMBNAIL) ? THUMBNAIL : ORIGINAL;
}

function ImagePreview({
  asset,
  imageProps = {},
  hideFileTypeIcon,
  type,
  darkMode,
  showOriginalImageAsThumbnail = false
}) {
  const { uploadStatus, loadedPercent } = asset || {};
  const assetFiles = _get(asset, 'assetFiles', {});
  const { sourceUrl } = getOriginalThumbnail(assetFiles, showOriginalImageAsThumbnail);
  const isVideoAsset = type === VIDEO;
  const isHeicAsset = type === HEIC;

  return (
    <div className="image-preview">
      <Image
        imageUrl={getImageUrl(isHeicAsset, sourceUrl)}
        width="100%"
        height="100%"
        backgroundSize="contain"
        defaultImageIcon={isVideoAsset ? 'projects' : fileTypeIconMap[type]}
        defaultIconSize={isHeicAsset ? 50 : void 0}
        defaultIconBackground={darkMode ? 'black' : 'catSkillWhite'}
        defaultIconColour={darkMode ? 'michael' : 'black'}
        {...imageProps} />

      {
      sourceUrl && !hideFileTypeIcon ?

      <FileTypeIcon
        className="image-preview__media-icon"
        name={isVideoAsset ? 'projects' : 'image'}
        color="white" /> :


      null}

      <Upload
        loadedPercent={loadedPercent}
        uploadStatus={uploadStatus}
        assetId={asset?.assetId} />

    </div>);

}

export default memo(ImagePreview);